<template>
  <div>
    <a-tabs defaultActiveKey="1" @change="callback">
      <a-tab-pane tab="消费记录" key="1" forceRender>
        <data-grid
          ref="dataGridConsume"
          :columns="consumeColumns1"
          api="RecVa_ReDetail"
          v-model="consumeData"
          :params="params"
          dataField="Data.DebitRecords"
          bordered
          :rowAction="false"
          @selectRow="costChange"
        >
          <template slot="action" slot-scope="text, record">
            <a-button
              type="link"
              v-if="Number(record.UnWriteOffAmount) > 0"
              @click="onWriteOff(record)"
              >核销</a-button
            >
            <a-button type="link" @click="onAccountToOrder(record)"
              >转账</a-button
            >
          </template>
        </data-grid>
      </a-tab-pane>
      <a-tab-pane tab="核销记录" key="2">
        <data-grid
          ref="dataGridWriteOff"
          :columns="consumeColumns2"
          api="RecVa_ReDetail"
          v-model="writeOffData"
          :params="params"
          dataField="Data.WriteOffRecords"
          bordered
        >
          <template slot="action" slot-scope="text, record">
            <a-button type="link" size="small" @click="revoke(record.Id)"
              >反核销</a-button
            >
          </template>
        </data-grid>
      </a-tab-pane>
    </a-tabs>
    <WriteOffDetail
      ref="writeOffDetail"
      :guestId="guestId"
      :orderNo="orderNo"
      @reloadDetail="reload()"
    />
    <TransferToOrder ref="TransferToOrder" @submit="reload"></TransferToOrder>
  </div>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";
import WriteOffDetail from "./WriteOffDetail.vue";
import TransferToOrder from "./TransferToOrder";
export default {
  name: "WriteLog",
  props: {
    logkeys: {
      type: String,
      default: ""
    },
    guestId: {
      type: String,
      default: ""
    },
    orderNo: {
      type: [String, Number],
      default: ""
    }
  },
  components: {
    DataGrid,
    WriteOffDetail,
    TransferToOrder
  },
  data() {
    return {
      params: { Id: this.logkeys },
      consumeData: [],
      writeOffData: [],
      consumeColumns1: [
        {
          title: "序号",
          width: "50px",
          align: "center",
          type: "indexcolumn"
        },
        {
          title: "单据号",
          width: "10%",
          dataIndex: "BillNo"
        },
        {
          title: "挂账日期",
          width: "100px",
          dataIndex: "AccountDate"
        },
        {
          title: "账项",
          dataIndex: "AccountItemName"
        },
        {
          title: "单价",
          align: "right",
          width: "8%",
          dataIndex: "UnitPrice"
        },
        {
          title: "数量",
          width: "6%",
          dataIndex: "Amount"
        },
        {
          title: "总价",
          align: "right",
          width: "8%",
          dataIndex: "TotalPrice"
        },
        {
          title: "操作员",
          width: "12%",
          dataIndex: "CreatorUserName"
        },
        {
          title: "操作日期",
          width: "150px",
          dataIndex: "CreationTime"
        },
        {
          title: "未核销金额",
          align: "right",
          width: "10%",
          dataIndex: "UnWriteOffAmount"
        },
        {
          title: "操作",
          dataIndex: "Id",
          width: 140,
          scopedSlots: { customRender: "action" }
        }
      ],
      consumeColumns2: [
        {
          title: "序号",
          width: "50px",
          align: "center",
          type: "indexcolumn"
        },
        {
          title: "单据号",
          width: "15%",
          dataIndex: "BillNo"
        },
        {
          title: "核销日期",
          width: "120px",
          dataIndex: "AccountDate"
        },
        {
          title: "账项",
          dataIndex: "AccountItemName"
        },
        {
          title: "核销金额",
          align: "right",
          width: "10%",
          dataIndex: "TotalPrice"
        },
        {
          title: "操作员",
          width: "15%",
          dataIndex: "CreatorUserName"
        },
        {
          title: "操作日期",
          width: "170px",
          dataIndex: "CreationTime"
        },
        {
          title: "操作",
          dataIndex: "Id",
          width: 80,
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  created() {},
  methods: {
    revoke(id) {
      const _this = this;
      this.$confirm({
        title: "确定反核销吗?",
        onOk() {
          _this.$post("RevokeWriteOff", { Id: id }).then(() => {
            _this.$message.success("操作成功");
            _this.reload();
          });
        }
      });
    },
    callback(key) {
      if (key == 1) {
        this.$emit("AccountState", true);
      } else if (key == 2) {
        this.$emit("AccountState", false);
      }
    },
    reload() {
      this.params = { Id: this.logkeys };
    },
    costChange(row) {
      this.$emit("selectRow", row.Id);
    },
    onWriteOff(rows) {
      this.$refs.writeOffDetail.show([rows]);
    },
    onAccountToOrder(row) {
      this.$refs.TransferToOrder.show({
        receivableId: this.logkeys,
        receivableDetailId: row.Id,
        customerId: this.guestId
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/
  .ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
/deep/ .ant-table-bordered .ant-table-tbody > tr > td {
  padding: 2px 3px 0 3px !important;
}
</style>
